import { buildComponent } from '#components'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

const OurTeam = buildComponent({
  name: 'our-team',
  onConnected: (component) => {
    initSwipers([...component.querySelectorAll<HTMLElement>('.swiper')])
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'our-team': typeof OurTeam
  }
}

function initSwipers(swiperEls: HTMLElement[]) {
  swiperEls.forEach((swiperEl) => {
    const slideCount = swiperEl.querySelectorAll<HTMLElement>('.swiper-slide').length

    new Swiper(swiperEl, {
      modules: [Navigation],
      slidesPerView: 1.3,
      spaceBetween: 20,
      speed: 500,
      breakpoints: {
        768: {
          slidesPerView: 2.5
        },
        990: {
          slidesPerView: slideCount > 4 ? 4.15 : 4,
          spaceBetween: 45
        }
      },
      navigation: {
        nextEl: swiperEl.querySelector<HTMLElement>('.swiper-button-next'),
        prevEl: swiperEl.querySelector<HTMLElement>('.swiper-button-prev')
      }
    })
  })
}
